import { ACTIONS } from '../../_config';
import { ActionExtended } from '../../_config/interfaces/interfaces';

export interface FilterState {
    source: string;
    keyword: string;
    startDate: string | null;
    endDate: string | null;
    minRating: number;
    maxRating: number;
    applied: any;
}

const initialState: FilterState = {
    source: '',
    keyword: '',
    startDate: null,
    endDate: null,
    minRating: 1,
    maxRating: 5,
    applied: {},
};

const filterReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.FILTER.SET:
            return {
                ...state,
                ...action.payload,
            };
        case ACTIONS.FILTER.CLEAR:
            return { ...initialState };
        default:
            return state;
    }
};

export default filterReducer;
